const chooseEvent = select => {
  const $dropdown = select.querySelector('.select-dropdown');
  $dropdown.addEventListener('click', () => {
    sessionStorage.setItem('newsFiltered', 'true');
  });
};
const toggleDropdown = (field, isOpen) => {
  field.classList.toggle('_visible', isOpen);
  field.setAttribute('aria-expanded', String(isOpen));
};
const getMenuItems = field => [...field.querySelectorAll('.select-dropdown a')];
const focusItemAt = (items, index) => {
  if (!items.length) return;
  items[(index + items.length) % items.length].focus();
};
const select = (field, index) => {
  const dropdown = field.querySelector('.select-dropdown');
  const items = getMenuItems(field);
  const dropdownId = `news-filter-dropdown-${index}`;
  dropdown.id = dropdownId;
  dropdown.setAttribute('role', 'menu');
  field.setAttribute('tabindex', '0');
  field.setAttribute('role', 'button');
  field.setAttribute('aria-haspopup', 'true');
  field.setAttribute('aria-expanded', 'false');
  field.setAttribute('aria-controls', dropdownId);
  items.forEach(item => {
    item.setAttribute('role', 'menuitem');
    item.setAttribute('tabindex', '-1');
  });
  field.addEventListener('click', () => {
    toggleDropdown(field, !field.classList.contains('_visible'));
  });
  field.addEventListener('keydown', e => {
    if (e.target !== field) return;
    switch (e.key) {
      case 'Enter':
      case ' ':
        e.preventDefault();
        toggleDropdown(field, !field.classList.contains('_visible'));
        if (field.classList.contains('_visible')) focusItemAt(items, 0);
        break;
      case 'ArrowDown':
        e.preventDefault();
        toggleDropdown(field, true);
        focusItemAt(items, 0);
        break;
      case 'ArrowUp':
        e.preventDefault();
        toggleDropdown(field, true);
        focusItemAt(items, items.length - 1);
        break;
      case 'Escape':
        toggleDropdown(field, false);
        break;
      default:
        break;
    }
  });
  dropdown.addEventListener('keydown', e => {
    const currentIndex = items.indexOf(document.activeElement);
    switch (e.key) {
      case 'ArrowDown':
        e.preventDefault();
        focusItemAt(items, currentIndex + 1);
        break;
      case 'ArrowUp':
        e.preventDefault();
        focusItemAt(items, currentIndex - 1);
        break;
      case 'Escape':
        e.preventDefault();
        toggleDropdown(field, false);
        field.focus();
        break;
      default:
        break;
    }
  });
  document.addEventListener('click', e => {
    if (!field.contains(e.target)) {
      toggleDropdown(field, false);
    }
  });
  field.addEventListener('focusout', e => {
    if (!field.contains(e.relatedTarget)) {
      toggleDropdown(field, false);
    }
  });
  chooseEvent(field);
};
const createWrap = translate => {
  const [$frame, $wrap, $clear] = ['div', 'div', 'button'].map(tag => document.createElement(tag));
  $frame.classList.add('frame', 'frame-layout-news-filter');
  $wrap.classList.add('news-filter', 'd-flex', 'container');
  $clear.classList.add('news-filter-clear', 'd-none');
  $clear.type = 'button';
  $clear.textContent = translate;
  return {
    $frame,
    $wrap,
    $clear
  };
};
const clearEvent = (clearBtn, rootHref) => {
  const isFiltered = sessionStorage.getItem('newsFiltered');
  if (isFiltered) clearBtn.classList.remove('d-none');
  clearBtn.addEventListener('click', () => {
    sessionStorage.removeItem('newsFiltered', 'true');
    window.location.href = rootHref;
  });
};
const filter = () => {
  const elementsList = [document.querySelector('.ce-news_categorylist'), document.querySelector('.ce-news_newsdatemenu')].filter(e => e);
  const fields = document.querySelectorAll('.news-filter-select');
  const el = document.querySelector('[data-filter-reset]');
  const rootHref = el ? el.href : '';
  const translate = el ? el.dataset.filterReset : '';
  const elements = createWrap(translate);
  if (elementsList.length) {
    elementsList[0].parentNode.insertBefore(elements.$frame, elementsList[0]);
    elements.$frame.appendChild(elements.$wrap);
    [...elementsList].forEach(element => elements.$wrap.appendChild(element));
    elements.$wrap.appendChild(elements.$clear);
  }
  if (fields) {
    fields.forEach((field, index) => select(field, index));
    clearEvent(elements.$clear, rootHref);
  }
};
export default filter;